import client from "../Client/HttpClient";
import { IStudentAttendanceDetailsModel } from "@/interfaces/modules";

const ApiPath = "StudentAttendanceDetails";

export default {
    /** GET api/StudentAttendanceDetails */
    GetAll: (): Promise<IStudentAttendanceDetailsModel[]> =>
        client.get(`${ApiPath}`),

    /** GET api/StudentAttendanceDetails/{id} */
    GetById: (id: number): Promise<IStudentAttendanceDetailsModel> =>
        client.get(`${ApiPath}/${id}`),

    /** GET api/StudentAttendanceDetails/bySession/{attendanceSessionId} */
    GetBySessionId: (attendanceSessionId: number): Promise<IStudentAttendanceDetailsModel[]> =>
        client.get(`${ApiPath}/bySession/${attendanceSessionId}`),

    /** GET api/StudentAttendanceDetails/byStudent/{studentId} */
    GetByStudentId: (studentId: number): Promise<IStudentAttendanceDetailsModel[]> =>
        client.get(`${ApiPath}/byStudent/${studentId}`),

    /** POST api/StudentAttendanceDetails */
    Post: (data: IStudentAttendanceDetailsModel): Promise<IStudentAttendanceDetailsModel> =>
        client.post(`${ApiPath}`, data),
};
